<template>
  <div class="category">
    <el-button type="primary" size="small" icon="el-icon-plus" @click="create">创建</el-button>
    <el-table :data="list" style="width: 100%" class="table">
      <el-table-column prop="title" label="分类名称" width="180"></el-table-column>
      <el-table-column prop="title_en" label="名称(英文)" width="180"></el-table-column>
      <el-table-column prop="weight" label="权重" width="180"></el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="250"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="[5, 10, 15, 20]" :page-size="per_page" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
    <el-dialog :title="action===0?'创建':'编辑'" :visible.sync="dialogVisible" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="分类名称" prop="title">
          <el-input v-model="form.title" placeholder="分类名称" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="分类名称(英文)" prop="title">
          <el-input v-model="form.title_en" placeholder="分类名称" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="权重" prop="weight" v-if="action===1">
          <el-input v-model="form.weight" placeholder="权重" style="width: 400px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="action===0" type="primary" @click="submit">确 定</el-button>
        <el-button v-show="action===1" type="primary" @click="saveChange">保存更改</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  data () {
    return {
      action: 0,
      list: [],
      dialogVisible: false,
      page: 1,
      per_page: 10,
      total: 0,
      current: {},
      form: {
        title: '',
        title_en: '',
        weight: 0
      },
      rules: {
        title: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      request({
        url: '/movie/tags',
        params: {
          per_page: this.per_page,
          page: this.page
        }
      }).then(res => {
        this.list = res.data.list
        this.total = res.data.item_total
      })
    },
    handleSizeChange (e) {
      this.per_page = e
      this.handleCurrentChange(1)
    },
    handleCurrentChange (e) {
      this.page = e
      this.getList()
    },
    create () {
      this.action = 0
      this.dialogVisible = true
    },
    editItem (row) {
      this.current = row
      this.action = 1
      this.dialogVisible = true
      this.form.title = row.title
      this.form.title_en = row.title_en
      this.form.weight = row.weight
    },
    submit () {
      request({
        url: '/movie/tags',
        method: 'post',
        data: {
          title: this.form.title,
          title_en: this.form.title_en
        }
      }).then(res => {
        this.$message.success('创建成功!')
        this.dialogVisible = false
        this.handleCurrentChange(1)
        this.$refs['form'].resetFields()
      })
    },
    saveChange () {
      request({
        url: '/movie/tags/' + this.current.uuid,
        method: 'patch',
        data: {
          type: 'update',
          attributes: {
            title: this.form.title,
            title_en: this.form.title_en,
            weight: this.form.weight || 100
          }
        }
      }).then(res => {
        this.$message.success('保存成功!')
        this.dialogVisible = false
        this.getList()
        this.$refs['form'].resetFields()
      })
    },
    deleteItem (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/movie/tags/' + row.uuid,
          method: 'delete'
        }).then(res => {
          this.$message.success('删除成功!')
          this.getList()
        })
      }).catch()
    }
  }
}
</script>
<style lang="less" scoped>
.table {
  border: 1px solid #ebeef5;
  border-bottom: none;
  margin-top: 10px;
}
.pager {
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/movie/category.vue